import React from 'react'
import InvestorHeader from '../pages/Investor/InvestorDeals/InvestorHeader'

const InvestorLayout = ({ children }) => {
    return (
        <div className='investor-layout'>
            <InvestorHeader />
            <div className="investor-main">
                <div className="investor-content">{children}</div>
            </div>
        </div>
    )
}

export default InvestorLayout